import {put, takeLatest, call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";
import {
    DELETE_TABLES,
    DELETE_TABLES_SUCCESS,
    DELETE_TABLES_ERROR
}
    from "../../actions/table";

function* deleteTablesSaga(action) {
    try {
        yield call(tableService.DeleteTables, action.payload)
        
        yield put({
            type: DELETE_TABLES_SUCCESS,
            payload: action.payload._ids
        });

    } catch (error) {
        yield put({
            type: DELETE_TABLES_ERROR,error: error.data
        });
    }
}


export function* deleteTablesSagaWatcher() {
    yield takeLatest(DELETE_TABLES, deleteTablesSaga);
}